// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const createCheckout = async (priceId, addOn, isSale) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    priceId,
    addOn,
    firstMonthSale: isSale
  }
  const { data } = await AxiosConfig.post(
    '/subscription/checkout-session',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const changeSubscription = async (priceId, addOn) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    priceId,
    addOn
  }
  const { data } = await AxiosConfig.post(
    '/subscription/change-subscription',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createTrialSubscription = async (payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/create-trial',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const createSetupIntent = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/create-setup-intent',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const applyCoupon = async (coupon) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/subscription/validate-coupon',
    { coupon },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}
export default {
  createCheckout,
  changeSubscription,
  createTrialSubscription,
  createSetupIntent,
  applyCoupon
}
